import { useEffect, useState } from "react";
import { Play } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";
import { IMAGES } from "@/lib/content";
import { api } from "@/lib/api";

export const IntroVideo = () => {
  const [settings, setSettings] = useState({});
  useEffect(() => {
    api.get("/settings").then((r) => setSettings(r.data)).catch(() => {});
  }, []);

  const introId = settings.intro_video_id;
  const channelUrl = settings.youtube_subscribe_url || settings.youtube_channel_url || "";

  return (
    <div className="card-surface overflow-hidden" data-testid="intro-video">
      <div className="relative aspect-video bg-black">
        {introId ? (
          <iframe
            className="absolute inset-0 w-full h-full"
            src={`https://www.youtube.com/embed/${introId}`}
            title="Introduction video"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          />
        ) : (
          <a
            href={channelUrl || "#"}
            onClick={(e) => !channelUrl && e.preventDefault()}
            target={channelUrl ? "_blank" : undefined}
            rel="noreferrer"
            className="group absolute inset-0 grid place-items-center"
            data-testid="intro-video-placeholder"
          >
            <img src={IMAGES.hero} alt="" className="absolute inset-0 w-full h-full object-cover opacity-40" />
            <span className="relative z-10 flex flex-col items-center gap-3">
              <span className="h-16 w-16 rounded-full bg-brand-cyan/90 grid place-items-center transition-transform group-hover:scale-110">
                <Play size={26} className="fill-current text-brand-base ml-1" />
              </span>
              <span className="text-white/80 text-sm">Introduction video — coming soon</span>
            </span>
          </a>
        )}
      </div>
    </div>
  );
};
